module.exports = __webpack_public_path__ + "images/banners/category_estimate/banner_category_bulk_68_8f8b1e23da6f329f5882abc8136b8970.png";